<!-- 订单 -->
<template>
    <div id="order" class="business-content-main">
        <div class="bread-nav">
            <div>您当前位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>客服</el-breadcrumb-item>
                <el-breadcrumb-item>询价管理</el-breadcrumb-item>
                <el-breadcrumb-item>订单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-name">订单号 :</div>
            <el-input
                    style="width: 180px"
                    class="search-item"
                    size="small"
                    v-model.trim="searchData.OrderCode"
                    placeholder="请输入询价单号">
            </el-input>
            <div class="search-name">时间:</div>
            <el-date-picker
                    :picker-options="startDateOps"
                    class="search-item"
                    v-model="searchData.BeginDate"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    size="small"
                    placeholder="选择日期">
            </el-date-picker>
            <span class="search-name">至</span>
            <el-date-picker
                    :picker-options="endDateOps"
                    class="search-item"
                    v-model="searchData.EndDate"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    size="small"
                    placeholder="选择日期">
            </el-date-picker>

            <div class="search-name">状态:</div>
            <el-select
                    size="small"
                    class="search-item"
                    v-model="searchData.State"
                    placeholder="请选择">
                <el-option
                        v-for="item in orderState"
                        :key="item.Tkey"
                        :label="item.TValue"
                        :value="item.Tkey">
                </el-option>
            </el-select>
            <!--<div class="search-name">客服组:</div>-->
            <!--<el-select-->
                    <!--@change="getServicesByGId"-->
                    <!--size="small"-->
                    <!--class="search-item"-->
                    <!--v-model="searchData.GroupId"-->
                    <!--placeholder="请选择">-->
                <!--<el-option-->
                        <!--v-for="item in serviceGroup"-->
                        <!--:key="item.Id"-->
                        <!--:label="item.Name"-->
                        <!--:value="item.Id">-->
                <!--</el-option>-->
            <!--</el-select>-->
            <!--<div class="search-name">客服人员:</div>-->
            <!--<el-select-->
                    <!--size="small"-->
                    <!--class="search-item"-->
                    <!--v-model="searchData.Id"-->
                    <!--placeholder="请选择">-->
                <!--<el-option-->
                        <!--v-for="item in services"-->
                        <!--:key="item.Id"-->
                        <!--:label="item.Name"-->
                        <!--:value="item.Id">-->
                <!--</el-option>-->
            <!--</el-select>-->
            <el-button type="primary" size="small" icon="el-icon-search" class="search-btn" @click="handleSearch">查询</el-button>
            <el-button type="primary" size="small" icon="el-icon-refresh" class="search-btn" @click="resetSearch">重置</el-button>
        </div>
        <div class="table-ctn">
            <el-table
                    :header-cell-style="{background:'#F2F6FC'}"
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        show-overflow-tooltip
                        width="190px"
                        prop="OrderCode"
                        label="单号">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="EntpName"
                        label="客户名称">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="PayTypeName"
                        label="支付方式">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="ShipTypeName"
                        label="发货方式">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="OrderAmount"
                        label="销售金额">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="ShipAmount"
                        label="运费">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="StateName"
                        label="状态">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="Creator"
                        label="创建人">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="CreateTime"
                        label="创建时间">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="Remark"
                        label="备注">
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'order',
        components: {},
        data() {
            return {
                startDateOps: {
                    disabledDate: (time) => {
                        if (this.searchData.EndDate != "") {
                            return  time.getTime() > new Date(this.searchData.EndDate);
                        }

                    }
                },
                endDateOps: {
                    disabledDate: (time) => {
                        if (this.searchData.BeginDate != "") {
                            return  time.getTime() < new Date(this.searchData.BeginDate);
                        }

                    }
                },
                orderState:[
                    {Tkey:'0',TValue:'待审核'},
                    {Tkey:'1',TValue:'待备货'},
                    {Tkey:'2',TValue:'已打包'},
                    {Tkey:'3',TValue:'等待快递收货出仓'},
                    {Tkey:'4',TValue:'已发货'},
                    {Tkey:'5',TValue:'已签收'},
                    {Tkey:'6',TValue:'已评价'},
                    {Tkey:'7',TValue:'已退货'},
                ],
                serviceGroup:[],
                services:[],
                searchData: {
                    OrderCode:'',
                    BeginDate:'',
                    EndDate:'',
                    State:'',
                    page:1, // 当前页数
                    limit:10, // 每页限制条数
                },
                tableData: [],
                tableDataLength:0,
                menu:[],
            }

        },
        mounted() {
            this.menu = this.$util.getNode('客户采购订单')
            this.serviceGroup = this.$store.state.ServiceGroup
            this.getTableData()
        },
        methods: {
            getTableData(){
                this.axios.get('/Inquiry/GetSaleOrderList',{
                    params: this.searchData

                })
                    .then((response)=> {
                        this.tableData = response.data.data
                        this.tableDataLength = response.data.count
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },
            //  根据客服组ID获取所有在职客服
            getServicesByGId(gId){
                this.$util.GetServicesByGId(gId).then(value => {
                    this.services = value
                    this.searchData.Id = ''
                })
            },
            handleSearch(){
                this.searchData.page = 1
                this.getTableData()
            },
            resetSearch(){
                this.searchData = {
                    OrderCode:'',
                    SId:'',
                    StartDate:'',
                    EndDate:'',
                    GroupId:'',
                    page:1, // 当前页数
                    limit:10, // 每页限制条数
                    key:'', //关键字查询
                }
            },
            handleSizeChange(val) {
                this.searchData.limit = val
                this.getTableData()
            },
            handleCurrentChange(val) {
                this.searchData.page = val
                this.getTableData()
            }
        }
    }
</script>
<style lang="less" scoped>

</style>
